import HTMLTemplate from './template.html'
import './styles.scss'
import { Settings } from '../Settings/Settings'

export const AlertManagementModal = (() => {
  const STORAGE_KEY = 'alert-management-dismissed'
  const SESSION_KEY = 'alert-management-session-shown'

  const vueComponent = {
    data() {
      return {
        showModal: false,
        dontShowAgain: false,
        observer: null,
        sessionKey: SESSION_KEY
      }
    },
    created() {
      // If user previously chose not to show again, respect it
      const dismissed = window.localStorage.getItem(STORAGE_KEY) === 'true'
      if (dismissed) return

      // If already shown during this login session, do not show again
      const shownThisSession = window.sessionStorage.getItem(this.sessionKey) === 'true'
      if (shownThisSession) return

      // If tutorial has already been seen, we can show immediately
      const tutorialSeen = window.localStorage.getItem('tutorial-seen') === 'true'
      const appTemplate = document.getElementsByClassName('app-template')[0]
      const tutorialOpen = appTemplate?.classList.contains('show-tutorial-modal')

      if (tutorialSeen && !tutorialOpen) {
        this.show()
      } else {
        // Wait for tutorial to finish (priority goes to tutorial)
        this.waitForTutorialToClose()
      }
    },
    beforeUnmount() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    },
    methods: {
      show() {
        this.showModal = true
        // Mark as shown for this login session
        try {
          window.sessionStorage.setItem(this.sessionKey, 'true')
        } catch (e) { /* ignore */ }
      },
      hide() {
        this.showModal = false
        if (this.dontShowAgain) {
          window.localStorage.setItem(STORAGE_KEY, 'true')
        }
      },
      managePreferences() {
        // Open Settings on Notifications tab
        try {
          if (Settings) {
            Settings.$data.activeSettingsSection = 'Notifications'
            Settings.$data.showSettings = true
          }
        } catch (e) { /* no-op if Settings not available */ }
        this.hide()
      },
      waitForTutorialToClose() {
        const appTemplate = document.getElementsByClassName('app-template')[0]
        if (!appTemplate) {
          // Fallback: show after short delay
          window.setTimeout(() => this.show(), 1000)
          return
        }

        // If tutorial is already closed but tutorial-seen is not yet set, show after brief delay
        if (!appTemplate.classList.contains('show-tutorial-modal')) {
          window.setTimeout(() => this.show(), 300)
          return
        }

        // Observe class changes and show when tutorial modal is closed
        this.observer = new MutationObserver(() => {
          const stillOpen = appTemplate.classList.contains('show-tutorial-modal')
          if (!stillOpen) {
            if (this.observer) {
              this.observer.disconnect()
              this.observer = null
            }
            this.show()
          }
        })
        this.observer.observe(appTemplate, { attributes: true, attributeFilter: ['class'] })
      }
    },
    template: HTMLTemplate
  }

  const DOMElement = document.getElementById('vue-alert-management')
  if (DOMElement === null) {
    return null
  } else {
    return Vue.createApp(vueComponent).mount(DOMElement)
  }
})()



